export enum HostType {
  LOCAL,
  DEV,
  QA,
  RT,
  PROD,
}
